module.exports = __webpack_public_path__ + "img/pr-12.bd3e53ac.png";